export const tattooWorks = [
  {
    id: 1,
    image: 'https://static.readdy.ai/image/8671031128391c697a2e9f09b82e3420/77df1f9831b6bbd1d4ce72a3c80c5e7c.jpeg',
    category: 'Realismo',
    style: 'Guerrero Espartano',
    duration: '15 horas',
    year: '2024'
  },
  {
    id: 2,
    image: 'https://static.readdy.ai/image/8671031128391c697a2e9f09b82e3420/b958601d2fe01b779833d541070c8006.jpeg',
    category: 'Realismo',
    style: 'Medusa con Serpientes',
    duration: '12 horas',
    year: '2024'
  },
  {
    id: 3,
    image: 'https://static.readdy.ai/image/8671031128391c697a2e9f09b82e3420/07baae0982c6d7bb207ca36b5198b2f1.jpeg',
    category: 'Realismo',
    style: 'Retrato Las Vegas',
    duration: '10 horas',
    year: '2024'
  },
  {
    id: 4,
    image: 'https://static.readdy.ai/image/8671031128391c697a2e9f09b82e3420/5e0e0e5e5e5e5e5e5e5e5e5e5e5e5e5e.jpeg',
    category: 'Realismo',
    style: 'Jesucristo',
    duration: '14 horas',
    year: '2024'
  },
  {
    id: 5,
    image: 'https://static.readdy.ai/image/8671031128391c697a2e9f09b82e3420/4e4e4e4e4e4e4e4e4e4e4e4e4e4e4e4e.jpeg',
    category: 'Realismo',
    style: 'Tigre Realista',
    duration: '13 horas',
    year: '2024'
  },
  {
    id: 6,
    image: 'https://static.readdy.ai/image/8671031128391c697a2e9f09b82e3420/27a2a60a63df455e9ede8acd56ae0cf8.jpeg',
    category: 'Realismo',
    style: 'León Majestuoso',
    duration: '16 horas',
    year: '2024'
  },
  {
    id: 7,
    image: 'https://images.unsplash.com/photo-1542727365-19732a80dcfd?w=800&h=600&fit=crop',
    category: 'Animales',
    style: 'Lobo Sombreado',
    duration: '9 horas',
    year: '2023'
  },
  {
    id: 8,
    image: 'https://images.unsplash.com/photo-1475403614135-5f1aa0eb5015?w=800&h=600&fit=crop',
    category: 'Retrato',
    style: 'Rostro Femenino',
    duration: '10 horas',
    year: '2023'
  },
  {
    id: 9,
    image: 'https://images.unsplash.com/photo-1519699047748-de8e457a634e?w=800&h=600&fit=crop',
    category: 'Cover-up',
    style: 'Transformación Artística',
    duration: '8 horas',
    year: '2023'
  },
  {
    id: 10,
    image: 'https://images.unsplash.com/photo-1594223274512-ad4803739b7c?w=800&h=600&fit=crop',
    category: 'Ornamental',
    style: 'Patrón Detallado',
    duration: '6 horas',
    year: '2023'
  },
  {
    id: 11,
    image: 'https://images.unsplash.com/photo-1581833971358-2c8b550f87b3?w=800&h=600&fit=crop',
    category: 'Manga',
    style: 'Sleeve Completo',
    duration: '20 horas',
    year: '2023'
  },
  {
    id: 12,
    image: 'https://images.unsplash.com/photo-1552728089-57bdde30beb3?w=800&h=600&fit=crop',
    category: 'Naturaleza',
    style: 'Águila Majestuosa',
    duration: '11 horas',
    year: '2024'
  }
];

export const reviews = [
  {
    id: 1,
    name: 'María González',
    rating: 5,
    date: 'Hace 2 meses',
    text: 'Increíble experiencia en Daro Tattoo. El trabajo de Daro es impecable, muy profesional y el estudio súper limpio. Mi tatuaje quedó exactamente como lo imaginaba. 100% recomendable.',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=600&fit=crop'
  },
  {
    id: 2,
    name: 'Carlos Ruiz',
    rating: 5,
    date: 'Hace 1 mes',
    text: 'Llevo tres tatuajes hechos con Daro y cada uno mejor que el anterior. Su atención al detalle es excepcional. El proceso de reserva es muy fácil y el trato es excelente.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=600&fit=crop'
  },
  {
    id: 3,
    name: 'Laura Martínez',
    rating: 5,
    date: 'Hace 3 semanas',
    text: 'Estaba nerviosa por mi primer tatuaje pero Daro me hizo sentir muy cómoda. Explicó todo el proceso, el estudio es impecable y el resultado superó mis expectativas. Volveré sin duda.',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=600&fit=crop'
  },
  {
    id: 4,
    name: 'Javier Sánchez',
    rating: 5,
    date: 'Hace 2 semanas',
    text: 'Profesionalidad al 100%. Daro es un artista de verdad, cada trazo está perfectamente ejecutado. El estudio en Adra es de primera calidad. Totalmente recomendado.',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=600&fit=crop'
  }
];

export const stats = [
  { number: '500+', label: 'Tatuajes Realizados' },
  { number: '10', label: 'Años de Experiencia' },
  { number: '100%', label: 'Satisfacción' }
];